import { EditCandidateWithAttachments } from './EditCandidateWithAttachments'

/**
 * Every user sees the candidate's CV files and can download or add them.
 * EditCandidateLegacy (text-only CV) is kept only as a rollback target.
 */
export const EditCandidate = () => <EditCandidateWithAttachments />
